
import react.FC
import react.dom.html.ReactHTML.a
import react.dom.html.ReactHTML.div

val Menu = FC<stoneSampleProp> { props ->
    div {
        id = "navbar"
        a{
            href = "index.html"
            + "Home"
        }
        AsPacStoneType.values().forEach{stone ->
            if (props.stoneType != stone)
                a{
                    href = "granitecolors.html?stype=${stone.stoneName}"
                    + "${stone.stoneName.replaceFirstChar { it.uppercase() }} Sample"
                }
        }
    }
}
